<div class="cards-grid">
    @if (isClassRegisterEditor) {
    <app-dashboard-card icon="assets/images/certificates/iconClassRegister.svg" [iconIsFile]=true title="Digitales Klassenbuch" [routerLink]="['/enaio-certificates', 'class-registers', 'home']"></app-dashboard-card>
    <app-dashboard-card icon="assets/images/certificates/iconCourses.svg" [iconIsFile]=true title="Kursbuch" [routerLink]="['/enaio-certificates', 'class-registers', 'courses']"></app-dashboard-card>
    }
    @if (isCertificateEditor) {
    <app-dashboard-card icon="assets/images/certificates/iconGradeBook.svg" [iconIsFile]=true title="Notenbuch" [routerLink]="['/enaio-certificates', 'grade-book', 'home']"></app-dashboard-card>
    <app-dashboard-card icon="assets/images/certificates/iconCertificates.svg" [iconIsFile]=true title="Zeugnisse" [routerLink]="['/enaio-certificates', 'home']"></app-dashboard-card>
    }
    @if (isPupilListEditor) {
    <app-dashboard-card icon="fas fa-users" title="Schülerliste" [routerLink]="['/enaio-certificates', 'global-pupil-list']"></app-dashboard-card>
    }
    @if (isFinalExamEditor) {        
        <app-dashboard-card icon="fas fa-lightbulb" title="Jahres- und Prüfungsnoten (MRP)" [routerLink]="['/enaio-certificates', 'class-registers', 'final-exams']"></app-dashboard-card>
    }
</div>